import styles from './styles.module.css';
import modalState from '../../../../state-observables/modal/ModalState';

/* Modal explaining what the Danger indicator means, and what actions the user can take to resolve the issue */
export default function DangerModal() {

    const onClose = () => {
        modalState.setModal(null, '');
    };

    return (
        <div className={styles.updateNotification}>
            <h2>Let's Secure Your Marty's Future!</h2>
            <br />
            <p>
                It looks like your Marty isn't registered for our warranty yet. Registering is easy and brings peace of mind, ensuring your robot's adventures are always supported.
            </p>
            <br />
            <p>
                To register and activate your warranty, just follow our simple <a href="https://userguides.robotical.io/martyv2/userguides/warrantyservice/start" target="_blank" rel="noreferrer">Warranty Registration Guide</a>.
                It’s quick and helps keep your Marty in top shape!
            </p>
            <div className={styles.closeModalButtonContainer}>
                <button className={styles.closeModalButton} onClick={onClose}>I'll Check It Out</button>
            </div>
        </div>

    );
}

